module.exports = __webpack_public_path__ + "static/media/IFUWebapp_v5.503771dc.pdf";